import React from 'react';
import styled from 'styled-components';

import { CurrencyFormat } from '@lt/components';
import { useTranslation } from '@lt/localization';

import type { IPopularDestinationsOfferRegionWithPrice } from 'src/routes/Home/store/popularDestinationsOffers/types';

export const RegionLabel = (
  props: IPopularDestinationsOfferRegionWithPrice,
) => {
  const { place, minPrice, link } = props;

  const { t } = useTranslation();

  if (!minPrice) return null;

  return (
    <RegionLabelContainer href={`${link}?ref_content=main_page`}>
      <RegionPlaceName>{place}</RegionPlaceName>
      <RegionPrice value={minPrice} prefix={`${t('filters.prices.from')} `} />
    </RegionLabelContainer>
  );
};

const RegionLabelContainer = styled.a`
  text-decoration: none;
  display: flex;
  flex-direction: column;

  border-radius: 11px;
  height: 38px;

  margin: 2px;
  padding: 3px 8px 5px 8px;
  box-sizing: border-box;

  background: #fff;
`;

const RegionPlaceName = styled.div`
  color: #007aff;

  font-size: 12px;
  line-height: 16px;
`;

const RegionPrice = styled(CurrencyFormat)`
  color: #4d4d4d;

  font-size: 11px;
  line-height: 14px;
`;
